import useMediaQuery from 'usehooks-ts/dist/esm/useMediaQuery/useMediaQuery'

export default function useSmallMobileMediaQuery() {
  return useMediaQuery(`(min-width: ${0}px) and (max-width: ${370}px) `)
}
